import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202604: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202604",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-04-01",
  endDate: "2026-04-30",
  impressions: 61136,
  clicks: 1260,
  adsSpendDollars: 4211,
  budgetDollars: 5000,
  salesDollars: 33115,
  bestEstimateRoas: 7.86,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.84,
  newCustomersAcquired: 78,
  reorderConversions: 40,
  dataAvailableAtDate: "2026-05-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
